export default {"src":"/_next/static/media/lt.8301dc54.svg","height":32,"width":32,"blurWidth":0,"blurHeight":0};